import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { isDev } from "../../../common-data/Commons";
import { isAprovalAllowedEmail } from "../../../common-data/Accessibles";
import { convertThenFormat } from "../../../common-data/Converts";

const GymTransferRequestListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
}) => {
  const {
    gymTransferRequestData,
    gymTransferRequestLoading,
    gymTransferRequestError,
  } = useSelector((state) => state.transfer);

  const isAdminCluster =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";
  const isApprovalAllowed =
    (isDev && isAdminCluster) || isAprovalAllowedEmail(userInfoData?.email);

  const iniTransferData = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniTransferData);

  useEffect(() => {
    if (
      !gymTransferRequestLoading &&
      !gymTransferRequestError &&
      gymTransferRequestData?.status &&
      gymTransferRequestData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: gymTransferRequestData.data,
        pagination:
          gymTransferRequestData?.pagination?.length > 0
            ? gymTransferRequestData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniTransferData);
    }
  }, [
    gymTransferRequestData,
    gymTransferRequestLoading,
    gymTransferRequestError,
  ]);

  const tbColumns = [
    {
      dataField: "details",
      text: "action",
      formatter: (_, row) => {
        const isPending = row?.status === "pending";

        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius27"
            style={{
              cursor: "pointer",
              background:
                row?.status === "pending"
                  ? "#EB8317"
                  : row?.status === "approved"
                  ? "#379C00"
                  : "#D90000",
              color: "#fff",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName:
                  row?.status === "pending" && isApprovalAllowed
                    ? "approval"
                    : "remarks",
                rowData: row,
              }))
            }>
            {isPending && isApprovalAllowed
              ? "click to approve/reject"
              : row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_from",
      text: "member detail",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150"
            // onClick={() => {
            //   setModValues((prevs) => ({
            //     ...prevs,
            //     isModOpen: true,
            //     modName: "plan-details",
            //     rowData: row,
            //   }));
            // }}
          >
            {row?.user_from_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_from_mobile || ""}
              <br />
              {row?.user_from_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_from",
      text: "transfer from (gym)",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.gym_from_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "gym_to",
      text: "transfer to (gym)",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.gym_to_name || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "transfered_by",
    //   text: "transferred by",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.transfered_by_name || "NA"}
    //         <br />
    //         <small className="lowercase underline gray">
    //           {row?.transfered_by_mobile || ""}
    //           <br />
    //           {row?.transfered_by_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "transfered_fee",
      text: "total transfer fee",
      formatter: (_, row) => (
        <span className="tb-data">
          <small className="gray underline">
            {`₹${convertThenFormat(row?.base_transfer_fee || 0)}`}
          </small>
          <br />
          {`₹${convertThenFormat(row?.transfered_fee || 0)}`}
        </span>
      ),
    },
    // {
    //   dataField: "aprv_rej_by",
    //   text: "approved/rejected by",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.aprv_rej_name || "NA"}
    //         <br />
    //         <small className="lowercase underline gray">
    //           {row?.aprv_rej_mobile || ""}
    //           <br />
    //           {row?.aprv_rej_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "aprv_rej_date",
    //   text: "approved/rejected date",
    //   formatter: (_, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.aprv_rej_date ? formatDateTimezon(row.aprv_rej_date) : "-"}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "date_added",
    //   text: "transfer date",
    //   formatter: (_, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
    //     </span>
    //   ),
    // },
    {
      dataField: "action",
      text: "view details",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16">
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
      {gymTransferRequestLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default GymTransferRequestListings;
